import { IAppFacade } from '../services/app-facade/app-facade.interface';

export abstract class Facade {

    constructor(protected appFacade: IAppFacade) {

    }

}



// WEBPACK FOOTER //
// ./src/core/facades/facade.ts